<ion-content>
  <app-header [title]="'Web Site Setting Admin'"></app-header>
  <div class="loading-container" style="padding-top:10%"  *ngIf="!loading">
      <ion-spinner></ion-spinner>
  </div>
  <ion-content class="ion-padding">
  <ion-grid >
    <form>

      <ion-row class="form-row" *ngFor="let set of systemSetting; let i = index">
        <ion-col size="12" size-md="4" class="label-cell">
          <b>{{set.displayName}}</b>
          <div class="helper-text">
         {{set.subDisplayText}}
          </div>
        </ion-col>
        <ion-col size="12" [attr.size-md]="set.size">
          <ion-row>
            <ion-input type="text"    [(ngModel)]="set.data"  [name]="'setting_' + i" placeholder=""></ion-input>
            <span class="inline-suffix">{{set.extra}}</span>
            </ion-row>
        </ion-col>
      </ion-row>
      <ion-row class="form-row">
        <ion-col size="12" size-md="4" class="label-cell">
          <b>Name Emblem Indicator</b>
          <div class="helper-text">
            Select Emblem Type which is used for Name Emblems
          </div>
        </ion-col>
        <ion-col size="12" size-md="3">
            <ion-select placeholder="Select Emblem Type" [(ngModel)]="selectedEmblemType">
            <ion-select-option *ngFor="let type of emblemsType" [value]="type.typeCode">
             {{type.typeCode}}-{{type.description}}
            </ion-select-option>
          </ion-select>
        </ion-col>
      </ion-row>

      <ion-row class="form-row">
        <ion-col size="12" size-md="4" class="label-cell">
          <b>Available Delivery Methods<br />for Web Orders</b>
        </ion-col>
        <ion-col size="12" size-md="8">
          <ion-row>
            <ion-col size="6" size-md="4" *ngFor="let del of availableDelivery">
              <ion-checkbox label-placement="end" [value]="del.methodCode" [checked]="del.isSelected" (ionChange)="toggleSelection(del, $event)"></ion-checkbox>
              <span style="margin-left:8px">{{del.description}}</span>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>

    
<ion-card>
  <ion-card-header>
    <ion-card-title class="ion-text-center">Select the Messages which are available for Web Order Garment Repairs</ion-card-title>
  </ion-card-header>
   <ion-card-content>
    <div class="checkbox-wrapper">
      <div class="checkbox-column" *ngFor="let message of messages">
          <ion-checkbox slot="start" [value]="message.messageCode" [checked]="message.isSelected"  (ionChange)="toggleSelection(message, $event)"></ion-checkbox>
          <ion-label style="padding-left:10px">{{  message.description }}</ion-label>
      </div>
    </div>
  </ion-card-content>
</ion-card>
      <ion-row class="ion-justify-content-center ion-padding-top">
        <ion-button color="gallaghergreen" type="submit" (click)="submitForm()">Submit</ion-button>
      </ion-row>

    </form>
  </ion-grid>
</ion-content>
</ion-content>
